import React from 'react'
import { Row, Col } from 'react-bootstrap';

export default function VariancePercentage({
  budgetBreakdown, 
  varianceBreakdown 
}) {
  const multiplier = 100;

  let revenuePercentage = (+varianceBreakdown.varianceRevenue / +budgetBreakdown.totalRevenue) * multiplier;
  let fullyLoadedPercentage = (+varianceBreakdown.varianceFullyLoadedCost / +budgetBreakdown.totalFullyLoadedCost) * multiplier;
  let unLoadedPercentage = (+varianceBreakdown.varianceUnloadedCost / +budgetBreakdown.totalUnloadedCost) * multiplier;
  let externalPercentage = (+varianceBreakdown.varianceExternalCost / +budgetBreakdown.totalExternalCost) * multiplier;
  let totalCostPercentage = (+varianceBreakdown.varianceTotalCost / +budgetBreakdown.totalCost) * multiplier;
  let profitBeforexTax = +varianceBreakdown.varianceProfitBeforeTax / +budgetBreakdown.profitBeforeTax;
  let profitNetofTax = +varianceBreakdown.varianceProfitNetofTax / +budgetBreakdown.profitNetofTax;

  revenuePercentage = !Number.isNaN(revenuePercentage) ? revenuePercentage.toFixed(2) : 0;
  fullyLoadedPercentage = !Number.isNaN(fullyLoadedPercentage) ? fullyLoadedPercentage.toFixed(2) : 0;
  unLoadedPercentage = !Number.isNaN(unLoadedPercentage) ? unLoadedPercentage.toFixed(2) : 0;
  externalPercentage = !Number.isNaN(externalPercentage) ? externalPercentage.toFixed(2) : 0;
  totalCostPercentage = !Number.isNaN(totalCostPercentage) ? totalCostPercentage.toFixed(2) : 0;
  profitBeforexTax = !Number.isNaN(profitBeforexTax) ? profitBeforexTax.toFixed(2) : 0;
  profitNetofTax = !Number.isNaN(profitNetofTax) ? profitNetofTax.toFixed(2) : 0;

  return (
    <>
      <Row>
        <Col className="align-center breakdown-total-revenue">
          { revenuePercentage }%
        </Col>
      </Row>
      <Row>
        <Col className="align-center breakdown-total-fully-loaded-cost">
          { fullyLoadedPercentage}%
        </Col>
      </Row>
      <Row>
        <Col className="align-center breakdown-total-unloaded-cost">
          { unLoadedPercentage }%
        </Col>
      </Row>
      <Row>
        <Col className="align-center breakdown-total-external-cost">
          { externalPercentage }%
        </Col>
      </Row>
      <Row>
        <Col className="align-center breakdown-total-cost">
          { totalCostPercentage }% 
        </Col>
      </Row>
      <Row>
        <Col className="align-center breakdown-total-profit-before-tax">
          { profitBeforexTax }%
        </Col>
      </Row>
      <Row>
        <Col className="align-center breakdown-total-profit-after-tax">
          { profitNetofTax }%
        </Col>
      </Row>
    </>
  )
}
